import gql from 'graphql-tag';

export const ADMIN_UPDATE_DASHBOARD = gql`
  mutation UpdateDashboard($input: UpdateExternalDashboardsInput!) {
    externalDashboards {
      result: adminUpdateDashboard(input: $input) {
        error
        success
        entity {
          id
        }
      }
    }
  }
`;
